export enum SideDoorClients {
  VAILLANT = 'Vaillant',
  BEKO = 'Beko',
  BAXI = 'Baxi',
  HOOVER = 'Hoover',
}
